module.exports = __webpack_public_path__ + "img/swiper-item1-1.54831496.png";